import './IndustryCell.scss';

import React from 'react';
import type { Cell } from 'react-table';

import Tooltip from '../../../../../common/Tooltip';
import bem from '../../../../../utils/bem';
import type { CampaignModel } from '../../modelConverters';

interface IndustryCellProps {
  cell: Cell<CampaignModel>;
}

const IndustryCell = ({ cell }: IndustryCellProps): JSX.Element | null => {
  const [block, element] = bem('industry-cell');
  const campaign = cell.row.original;

  const displayText = cell.value;

  const fullList = campaign.industryList?.map((industry) => industry.name).join('<br>') ?? '';
  const tooltip = (
    <Tooltip
      id={`industry-${campaign.id}`}
      message={fullList}
      className={element('industries_tooltip')}
      shouldRenderInPortal={false}
    >
      <div className={element('industries')}>{displayText}</div>
    </Tooltip>
  );
  return <div className={block()}>{tooltip}</div>;
};

export default IndustryCell;
